export default () => {
  document.querySelectorAll('.select .is-danger').forEach((select) => {
    select.parentElement.classList.add('is-danger');
  });
}
